__webpack_require__.p = "https://word-addon.legalassistant.au/";